/** Impls dos use cases de Fundação (S1). @since S1 */
import type {
  Agenciador, UpsertAgenciadorCommand,
  EmailTemplate, UpsertEmailTemplateCommand,
  ExternalIntegration, UpsertExternalIntegrationCommand,
  TenantFinancialConfig, UpsertTenantFinancialConfigCommand,
} from '@/domain/model/Fundacao';
import type {
  AgenciadorGateway, EmailTemplateGateway,
  ExternalIntegrationGateway, TenantFinancialConfigGateway,
} from '@/application/port/out/FundacaoGateways';
import type {
  ListAgenciadoresUseCase, CreateAgenciadorUseCase, UpdateAgenciadorUseCase, RemoveAgenciadorUseCase,
  ListEmailTemplatesUseCase, CreateEmailTemplateUseCase, UpdateEmailTemplateUseCase,
  RemoveEmailTemplateUseCase, PreviewEmailTemplateUseCase,
  ListIntegracoesUseCase, CreateIntegracaoUseCase, UpdateIntegracaoUseCase, RemoveIntegracaoUseCase,
  GetTenantFinancialConfigUseCase, SaveTenantFinancialConfigUseCase,
} from '@/application/port/in/FundacaoUseCase';

export class ListAgenciadores implements ListAgenciadoresUseCase {
  constructor(private readonly g: AgenciadorGateway) {}
  execute(): Promise<Agenciador[]> { return this.g.list(); }
}
export class CreateAgenciador implements CreateAgenciadorUseCase {
  constructor(private readonly g: AgenciadorGateway) {}
  execute(cmd: UpsertAgenciadorCommand): Promise<Agenciador> { return this.g.create(cmd); }
}
export class UpdateAgenciador implements UpdateAgenciadorUseCase {
  constructor(private readonly g: AgenciadorGateway) {}
  execute(id: string, cmd: UpsertAgenciadorCommand): Promise<Agenciador> { return this.g.update(id, cmd); }
}
export class RemoveAgenciador implements RemoveAgenciadorUseCase {
  constructor(private readonly g: AgenciadorGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}

export class ListEmailTemplates implements ListEmailTemplatesUseCase {
  constructor(private readonly g: EmailTemplateGateway) {}
  execute(): Promise<EmailTemplate[]> { return this.g.list(); }
}
export class CreateEmailTemplate implements CreateEmailTemplateUseCase {
  constructor(private readonly g: EmailTemplateGateway) {}
  execute(cmd: UpsertEmailTemplateCommand): Promise<EmailTemplate> { return this.g.create(cmd); }
}
export class UpdateEmailTemplate implements UpdateEmailTemplateUseCase {
  constructor(private readonly g: EmailTemplateGateway) {}
  execute(id: string, cmd: UpsertEmailTemplateCommand): Promise<EmailTemplate> { return this.g.update(id, cmd); }
}
export class RemoveEmailTemplate implements RemoveEmailTemplateUseCase {
  constructor(private readonly g: EmailTemplateGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
export class PreviewEmailTemplate implements PreviewEmailTemplateUseCase {
  constructor(private readonly g: EmailTemplateGateway) {}
  execute(id: string, vars: Record<string, string>): Promise<string> { return this.g.preview(id, vars); }
}

export class ListIntegracoes implements ListIntegracoesUseCase {
  constructor(private readonly g: ExternalIntegrationGateway) {}
  execute(): Promise<ExternalIntegration[]> { return this.g.list(); }
}
export class CreateIntegracao implements CreateIntegracaoUseCase {
  constructor(private readonly g: ExternalIntegrationGateway) {}
  execute(cmd: UpsertExternalIntegrationCommand): Promise<ExternalIntegration> { return this.g.create(cmd); }
}
export class UpdateIntegracao implements UpdateIntegracaoUseCase {
  constructor(private readonly g: ExternalIntegrationGateway) {}
  execute(id: string, cmd: UpsertExternalIntegrationCommand): Promise<ExternalIntegration> { return this.g.update(id, cmd); }
}
export class RemoveIntegracao implements RemoveIntegracaoUseCase {
  constructor(private readonly g: ExternalIntegrationGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}

export class GetTenantFinancialConfig implements GetTenantFinancialConfigUseCase {
  constructor(private readonly g: TenantFinancialConfigGateway) {}
  execute(): Promise<TenantFinancialConfig> { return this.g.get(); }
}
export class SaveTenantFinancialConfig implements SaveTenantFinancialConfigUseCase {
  constructor(private readonly g: TenantFinancialConfigGateway) {}
  execute(cmd: UpsertTenantFinancialConfigCommand): Promise<TenantFinancialConfig> { return this.g.save(cmd); }
}
